import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";

interface CategoryData {
  category: string;
  interaction_count: number;
}

interface Props {
  data: CategoryData[];
}

const COLORS = [
  "hsl(var(--primary))",
  "hsl(var(--accent))",
  "hsl(var(--secondary))",
  "hsl(220, 70%, 50%)",
  "hsl(280, 70%, 50%)",
  "hsl(340, 70%, 50%)",
  "hsl(40, 70%, 50%)",
  "hsl(160, 70%, 50%)",
  "hsl(200, 70%, 50%)",
  "hsl(260, 70%, 50%)",
];

export default function CategoryBreakdownChart({ data }: Props) {
  if (!data || data.length === 0) {
    return (
      <div className="h-80 flex items-center justify-center text-muted-foreground">
        No category interaction data available
      </div>
    );
  }

  // Take top 10 categories
  const topCategories = data.slice(0, 10);

  return (
    <ResponsiveContainer width="100%" height={400}>
      <PieChart>
        <Pie
          data={topCategories}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={({ category, percent }) => 
            `${category}: ${(percent * 100).toFixed(0)}%`
          }
          outerRadius={120}
          fill="hsl(var(--primary))"
          dataKey="interaction_count"
        >
          {topCategories.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip 
          contentStyle={{ 
            backgroundColor: "hsl(var(--background))",
            border: "1px solid hsl(var(--border))",
            borderRadius: "8px"
          }}
          formatter={(value) => [`${value} interactions`, "Count"]}
        />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
}
